<template>
<div class="chapter">
<div class="inner_page">
<div style="margin-top:2em;">
<h2 class="h2v"><a id="page_xv"></a>NOTE ON TRANSLATIONS</h2>
<p class="noindent">No translation of the <em>Cratylus</em> is perfect—a hermeneutical fact owed not to the failures of any particular translator, but to the richness and essential ambiguities of the <em>Cratylus</em> itself. In what follows I have made extensive use of Joe Sachs’ excellent translation, as well as that of the great H. N. Fowler. In order to emphasize certain themes or correct what I perceive to be misleading phrases, I have occasionally modified the translations. (In particular, I have opted for the more common “correct” over Sachs’ “rightness” for interpretive reasons that will become clear.) Occasionally I offer my “own” translations (whatever that means), though even in these cases, I often use the generally superior translations of Sachs and Fowler for orientation and verification.</p>
<p class="indent">It is recommended, but by no means necessary, that one keep the Greek text handy as one reads the following book, even if one does not read Greek. As will be seen, the principle behind Socrates’ view of language entails the material (which is to say visible and audible) similarities between words. It is therefore exceedingly helpful for understanding the text to be able to look upon these similarities as they occur. <em>It is impossible to do so with any translation, no matter how good.</em> The <em>Cratylus,</em> perhaps more than any other Greek text, demands <em>to be looked at.</em><a id="page_xvi"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Note1.vue?21904b7e